import { Link } from 'react-router-dom';

type TProps = {
  setClickedOk: React.Dispatch<React.SetStateAction<boolean>>;
};
const Cookies = ({ setClickedOk }: TProps) => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        justifyContent: 'space-between',
        padding: '15px',
        position: 'fixed',
        bottom: 0,
        width: '100%',
        paddingRight: '90px',
        alignItems: 'center',
        zIndex: '10000',
      }}
    >
      <div className='text-xs'>
        We use cookies to ensure you get the best experience on our website
      </div>
      <div className='flex gap-[15px] text-xs'>
        <Link to='/privacy-policy'>
          <div
            className='text-green'
            style={{
              backgroundColor: 'whitesmoke',
              padding: '7px',
              cursor: 'pointer',
              borderRadius: '6px',
            }}
          >
            Read More
          </div>
        </Link>
        <div
          onClick={() => {
            localStorage.setItem('cookieAccepted', 'true');
            setClickedOk(true);
          }}
          className='bg-green'
          style={{
            color: 'white',
            padding: '7px 15px',
            cursor: 'pointer',
            borderRadius: '6px',
          }}
        >
          OK
        </div>
      </div>
    </div>
  );
};

export default Cookies;
